import { useFilterLabel } from "../../hooks/useFilterLabel";

import React, { useState, useEffect, useRef, useReducer } from "react";
import { useAuthDataContext } from "../../containers/AuthDataProvider";
import PersistentDrawerLeft from "../../components/part/PersistentDrawerLeft";
import CreateArticleFab from "../../components/part/CreateArticleFab";
import ArticleProvider from "../part/ArticleProvider";

import AttachmentList from "../../components/part/AttachmentList";

export default function MediaPage() {
  const user = useAuthDataContext();

  const [isLoading, setIsLoading] = useState(true);

  // ラベル・フィルターの追加
  const { filterLabelName, filterLabelColor, handleLabelFileter } = useFilterLabel();

  const ARTICLE_CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION";
  const ARTICLE_UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";
  const ARTICLE_DELETE_SUBSCRIPTION = "DELETE_SUBSCRIPTION";
  const ARTICLE_INITIAL_QUERY = "INITIAL_QUERY";
  const ARTICLE_ADDITIONAL_QUERY = "ADDITIONAL_QUERY";

  const articleReducer = (state, action) => {
    switch (action.type) {
      case ARTICLE_INITIAL_QUERY:
        return action.articles;
      case ARTICLE_ADDITIONAL_QUERY:
        return [...state, ...action.articles];
      case ARTICLE_CREATE_SUBSCRIPTION:
        return [action.article, ...state];
      case ARTICLE_UPDATE_SUBSCRIPTION:
        var updatePos = state.map((x) => x.id).indexOf(action.article.id);
        state.splice(updatePos, 1, action.article);
        return [...state];
      case ARTICLE_DELETE_SUBSCRIPTION:
        var deletePos = state.map((x) => x.id).indexOf(action.article.id);
        state.splice(deletePos, 1);
        return [...state];
      default:
        return state;
    }
  };

  const [articles, dispatchArticle] = useReducer(articleReducer, []);
  useEffect(() => {
    const storageVar = JSON.parse(sessionStorage.getItem("articles"));
    if (storageVar) {
      dispatchArticle(storageVar);
    }
  }, []);
  useEffect(() => {
    sessionStorage.setItem("articles", JSON.stringify(articles));
  }, [articles]);

  const [articlesNextToken, setArticlesNextToken] = useState(null);
  useEffect(() => {
    sessionStorage.setItem("articlesNextToken", JSON.stringify(articlesNextToken));
  }, [articlesNextToken]);
  useEffect(() => {
    const storageVar = JSON.parse(sessionStorage.getItem("articlesNextToken"));
    if (storageVar) {
      setArticlesNextToken(storageVar);
    }
  }, []);

  const refArticleAttachmentProvider = useRef();

  const [attachmentsOffset, setAttachmentsOffset] = useState(null);
  useEffect(() => {
    sessionStorage.setItem("attachmentsOffset", JSON.stringify(attachmentsOffset));
  }, [attachmentsOffset]);
  useEffect(() => {
    const storageVar = JSON.parse(sessionStorage.getItem("attachmentsOffset"));
    if (storageVar) {
      setAttachmentsOffset(storageVar);
    }
  }, []);

  const scrollToPrevious = React.useCallback(() => {
    window.scrollTo({
      top: attachmentsOffset,
      behavior: "smooth",
    });
  }, [attachmentsOffset]);

  function putScrollSession() {
    let _offset =
      window.pageYOffset ||
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    // setAttachmentsOffset(_offset);
    // なぜかこれだと、useEffectのreturn時(unmount時)にセットできないので、下の行のように直接sessionStorageにセットした
    sessionStorage.setItem("attachmentsOffset", _offset);
  }

  useEffect(() => {
    scrollToPrevious();
  }, [isLoading, scrollToPrevious]);

  sessionStorage.setItem("prevPage", "/media");

  return (
    <React.Fragment>
      <ArticleProvider
        ref={refArticleAttachmentProvider}
        user={user}
        articles={articles}
        dispatchArticle={dispatchArticle}
        articlesNextToken={articlesNextToken}
        setArticlesNextToken={setArticlesNextToken}
        putScrollSession={putScrollSession}
        scrollToPrevious={scrollToPrevious}
        setIsLoading={setIsLoading}
      ></ArticleProvider>
      <PersistentDrawerLeft
        type="photo"
        handleLabelFileter={handleLabelFileter}
        filterLabelName={filterLabelName}
        filterLabelColor={filterLabelColor}
        setIsLoading={setIsLoading}
      >
        {!!refArticleAttachmentProvider.current && (
          <AttachmentList
            isLoading={isLoading}
            articles={articles}
            getAdditionalArticles={refArticleAttachmentProvider.current.getAdditionalArticles}
            articlesNextToken={articlesNextToken}
            filterLabelName={filterLabelName}
          />
        )}
        <CreateArticleFab />
      </PersistentDrawerLeft>
    </React.Fragment>
  );
}
